/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SearchCriteria from './SearchCriteria';

/**
 * The SearchRequest model module.
 * @module model/SearchRequest
 * @version 1.0.0
 */
class SearchRequest {
    /**
     * Constructs a new <code>SearchRequest</code>.
     * @alias module:model/SearchRequest
     */
    constructor() { 
        
        SearchRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchRequest} obj Optional instance to populate.
     * @return {module:model/SearchRequest} The populated <code>SearchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchRequest();

            if (data.hasOwnProperty('sortField')) {
                obj['sortField'] = ApiClient.convertToType(data['sortField'], 'String');
            }
            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageSize')) {
                obj['pageSize'] = ApiClient.convertToType(data['pageSize'], 'Number');
            }
            if (data.hasOwnProperty('sortOrder')) {
                obj['sortOrder'] = ApiClient.convertToType(data['sortOrder'], 'String');
            }
            if (data.hasOwnProperty('searchCriteria')) {
                obj['searchCriteria'] = ApiClient.convertToType(data['searchCriteria'], [SearchCriteria]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SearchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SearchRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sortField'] && !(typeof data['sortField'] === 'string' || data['sortField'] instanceof String)) {
            throw new Error("Expected the field `sortField` to be a primitive type in the JSON string but got " + data['sortField']);
        }
        // ensure the json data is a string
        if (data['sortOrder'] && !(typeof data['sortOrder'] === 'string' || data['sortOrder'] instanceof String)) {
            throw new Error("Expected the field `sortOrder` to be a primitive type in the JSON string but got " + data['sortOrder']);
        }
        if (data['searchCriteria']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['searchCriteria'])) {
                throw new Error("Expected the field `searchCriteria` to be an array in the JSON data but got " + data['searchCriteria']);
            }
            // validate the optional field `searchCriteria` (array)
            for (const item of data['searchCriteria']) {
                SearchCriteria.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * The field to sort the results by.
 * @member {module:model/SearchRequest.SortFieldEnum} sortField
 */
SearchRequest.prototype['sortField'] = undefined;

/**
 * @member {Number} page
 */
SearchRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageSize
 */
SearchRequest.prototype['pageSize'] = undefined;

/**
 * The order to sort the results by.
 * @member {module:model/SearchRequest.SortOrderEnum} sortOrder
 */
SearchRequest.prototype['sortOrder'] = undefined;

/**
 * @member {Array.<module:model/SearchCriteria>} searchCriteria
 */
SearchRequest.prototype['searchCriteria'] = undefined;





/**
 * Allowed values for the <code>sortField</code> property.
 * @enum {String}
 * @readonly
 */
SearchRequest['SortFieldEnum'] = {

    /**
     * value: "created"
     * @const
     */
    "created": "created",

    /**
     * value: "title"
     * @const
     */
    "title": "title",

    /**
     * value: "tapeID"
     * @const
     */
    "tapeID": "tapeID"
};


/**
 * Allowed values for the <code>sortOrder</code> property.
 * @enum {String}
 * @readonly
 */
SearchRequest['SortOrderEnum'] = {

    /**
     * value: "asc"
     * @const
     */
    "asc": "asc",

    /**
     * value: "desc"
     * @const
     */
    "desc": "desc"
};



export default SearchRequest;

